import { Icon } from '@signavio/ui';
export default Icon;